<template>
    <div class="d-flex flex-column flex-column-fluid">
        <!-- Toolbar -->
        <div id="kt_app_toolbar" class="app-toolbar py-6 py-lg-6">
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                        منصة أكاديميا Academia
                    </h1>
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li class="breadcrumb-item text-muted">
                            <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
                        </li>
                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li class="breadcrumb-item text-muted"> الدروس الخاصة</li>
                    </ul>
                </div>
                <div class="d-flex align-items-center gap-2 gap-lg-3">
                    <button @click="$router.go(-1)" class="btn btn-light"
                        style="font-weight: 600;padding: 8px 20px;margin-left: 15px;background: #d7d7d745;">
                        رجوع <i class="fa fa-arrow-left" style="color: #07c232; margin-right: 10px"></i></button>
                </div>
            </div>
        </div>
        <!-- Content -->

        <div id="kt_app_content" class="app-content flex-column-fluid">
            <div id="kt_app_content_container" class="app-container container-fluid">
                <div v-if="isLoading == true"
                    style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
                    class="loader text-success">
                    جاري التحميل
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only"></span>
                    </div>
                </div>
                <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
                    <div class="card text-center p-5 not-login">
                        <span class="icon"><i class="bi bi-person-badge"></i></span>
                        <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار </h3>
                        <span>
                            <a href="login" class="btn btn-success">
                                تسجيل الدخول <i class="fa fa-sign-in"></i>
                            </a>
                        </span>
                    </div>
                </div>
                <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
                    <div class="col-md-12" v-if="isLoading == false && isLoggedIn == true">

                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card shadow-sm">
                                    <div class="card-header text-white" style="background:#03c044">
                                        <h3 class="card-title" style="color:#fff"> المراجعات <i
                                                class="fa fa-refresh text-white" style="margin:5px"></i>
                                        </h3>
                                    </div>
                                    <div class="card-body">
                                        <p class="text-muted"> حدد الفئة والتخصص وإختر من أدناه الاستاذ وقم بإختيار
                                            الجلسة للمراجعة</p>
                                        <hr>
                                        <!-- Categories Select -->
                                        <div class="row mb-4">
                                            <div class="col-md-6">
                                                <label for="categoriesSelect" class="form-label">الفئات</label>
                                                <select id="categoriesSelect" class="form-select"
                                                    v-model="selectedCategory" @change="filterSubCategories">
                                                    <option value="" disabled>اختر الفئة</option>
                                                    <option v-for="category in categories" :key="category.id"
                                                        :value="category.id">
                                                        {{ category.title }}
                                                    </option>
                                                </select>
                                            </div>

                                            <!-- Subcategories Select -->
                                            <div class="col-md-6">
                                                <label for="subCategoriesSelect" class="form-label"> التخصصات</label>
                                                <select id="subCategoriesSelect" class="form-select"
                                                    v-model="selectedSubCategory" @change="fetchSubscriptions">
                                                    <option value="" disabled>اختر التخصص</option>
                                                    <option v-for="subCategory in subCategories" :key="subCategory.id"
                                                        :value="subCategory.id">
                                                        {{ subCategory.title }}
                                                    </option>
                                                    <option v-if="subCategories.length === 0" disabled>لا توجد فئات
                                                        فرعية</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-12 mb-xl-10">
                                <!--begin::List widget 20-->
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="card mb-5 mb-xl-8 mt-5">
                                            <!--begin::Body-->
                                            <div class="card-body pb-0">
                                                <!--begin::Header-->
                                                <div class="d-flex align-items-center mb-5">
                                                    <!--begin::User-->
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <!--begin::Avatar-->
                                                        <div class="symbol symbol-50px me-5">
                                                            <img src="assets/img/ins-2.jpeg" alt="">
                                                        </div>
                                                        <!--end::Avatar-->
                                                        <!--begin::Info-->
                                                        <div class="d-flex flex-column">
                                                            <a href="#"
                                                                class="text-gray-900 text-hover-primary fs-6 fw-bold">
                                                                د.محمد شلوف</a>
                                                            <span class="text-gray-400 fw-bold">طب،علوم طبية</span>

                                                        </div>
                                                        <!--end::Info-->
                                                    </div>
                                                    <!--end::User-->
                                                    <!--begin::Menu-->
                                                    <div class="my-0">
                                                        <div class="rating">
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!--end::Menu-->
                                                </div>
                                                <!--end::Header-->
                                                <!--begin::Post-->
                                                <div class="mb-5">
                                                    <!--begin::Text-->
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <p class="text-gray-800 fw-normal mb-5">
                                                            <div
                                                                style="border: 1px solid #f1416c;border-radius: 10px;text-align: center;padding: 10px;background: #f1416c0d;">
                                                                <span class="badge badge-danger"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 12:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-danger mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    01/08/2025
                                                                </span>

                                                            </div>

                                                            </p>
                                                        </div>
                                                        <div class="col-md-6"
                                                            style="text-align: center;margin-top: 17px;">
                                                            <div
                                                                style="border: 1px solid #50cd89;border-radius: 10px;text-align: center;padding: 10px;background: #50cd890d;">
                                                                <span class="badge badge-success"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 01:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-success mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    05/09/2025
                                                                </span>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" style="text-align: left;">
                                                            <button class="btn btn-danger  btn-sm m-2"> <i
                                                                    class="fa fa-close"></i> إسترجاع </button>
                                                            <button class="btn btn-success btn-sm m-2"> <i
                                                                    class="fa fa-check-circle"></i> قبول </button>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <!--end::Body-->
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-5 mb-xl-8 mt-5">
                                            <!--begin::Body-->
                                            <div class="card-body pb-0">
                                                <!--begin::Header-->
                                                <div class="d-flex align-items-center mb-5">
                                                    <!--begin::User-->
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <!--begin::Avatar-->
                                                        <div class="symbol symbol-50px me-5">
                                                            <img src="assets/img/ins-2.jpeg" alt="">
                                                        </div>
                                                        <!--end::Avatar-->
                                                        <!--begin::Info-->
                                                        <div class="d-flex flex-column">
                                                            <a href="#"
                                                                class="text-gray-900 text-hover-primary fs-6 fw-bold">
                                                                د.محمد شلوف</a>
                                                            <span class="text-gray-400 fw-bold">طب،علوم طبية</span>

                                                        </div>
                                                        <!--end::Info-->
                                                    </div>
                                                    <!--end::User-->
                                                    <!--begin::Menu-->
                                                    <div class="my-0">
                                                        <div class="rating">
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!--end::Menu-->
                                                </div>
                                                <!--end::Header-->
                                                <!--begin::Post-->
                                                <div class="mb-5">
                                                    <!--begin::Text-->
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <p class="text-gray-800 fw-normal mb-5">
                                                            <div
                                                                style="border: 1px solid #f1416c;border-radius: 10px;text-align: center;padding: 10px;background: #f1416c0d;">
                                                                <span class="badge badge-danger"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 12:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-danger mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    01/08/2025
                                                                </span>

                                                            </div>

                                                            </p>
                                                        </div>
                                                        <div class="col-md-6"
                                                            style="text-align: center;margin-top: 17px;">
                                                            <div
                                                                style="border: 1px solid #50cd89;border-radius: 10px;text-align: center;padding: 10px;background: #50cd890d;">
                                                                <span class="badge badge-success"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 01:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-success mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    05/09/2025
                                                                </span>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" style="text-align: left;">
                                                            <button class="btn btn-danger  btn-sm m-2"> <i
                                                                    class="fa fa-close"></i> إسترجاع </button>
                                                            <button class="btn btn-success btn-sm m-2"> <i
                                                                    class="fa fa-check-circle"></i> قبول </button>
                                                        </div>
                                                    </div>

                                                    <!--end::Text-->

                                                </div>
                                                <!--end::Post-->

                                                <!--begin::Reply input-->

                                                <!--edit::Reply input-->
                                            </div>
                                            <!--end::Body-->
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-5 mb-xl-8 mt-5">
                                            <!--begin::Body-->
                                            <div class="card-body pb-0">
                                                <!--begin::Header-->
                                                <div class="d-flex align-items-center mb-5">
                                                    <!--begin::User-->
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <!--begin::Avatar-->
                                                        <div class="symbol symbol-50px me-5">
                                                            <img src="assets/img/ins-3.png" alt="">
                                                        </div>
                                                        <!--end::Avatar-->
                                                        <!--begin::Info-->
                                                        <div class="d-flex flex-column">
                                                            <a href="#"
                                                                class="text-gray-900 text-hover-primary fs-6 fw-bold">
                                                                د. نادر التونسي</a>
                                                            <span class="text-gray-400 fw-bold">طب،علوم طبية</span>

                                                        </div>
                                                        <!--end::Info-->
                                                    </div>
                                                    <!--end::User-->
                                                    <!--begin::Menu-->
                                                    <div class="my-0">
                                                        <div class="rating">
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!--end::Menu-->
                                                </div>
                                                <!--end::Header-->
                                                <!--begin::Post-->
                                                <div class="mb-5">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <p class="text-gray-800 fw-normal mb-5">
                                                            <div
                                                                style="border: 1px solid #f1416c;border-radius: 10px;text-align: center;padding: 10px;background: #f1416c0d;">
                                                                <span class="badge badge-danger"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 12:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-danger mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    01/08/2025
                                                                </span>

                                                            </div>

                                                            </p>
                                                        </div>
                                                        <div class="col-md-6"
                                                            style="text-align: center;margin-top: 17px;">
                                                            <div
                                                                style="border: 1px solid #50cd89;border-radius: 10px;text-align: center;padding: 10px;background: #50cd890d;">
                                                                <span class="badge badge-success"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 01:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-success mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    05/09/2025
                                                                </span>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" style="text-align: left;">
                                                            <button class="btn btn-danger  btn-sm m-2"> <i
                                                                    class="fa fa-close"></i> إسترجاع </button>
                                                            <button class="btn btn-success btn-sm m-2"> <i
                                                                    class="fa fa-check-circle"></i> قبول </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end::Post-->
                                                <!--begin::Separator-->
                                                <div class="separator mb-4"></div>
                                                <!--end::Separator-->
                                                <!--begin::Reply input-->

                                                <!--edit::Reply input-->
                                            </div>
                                            <!--end::Body-->
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-5 mb-xl-8 mt-5">
                                            <!--begin::Body-->
                                            <div class="card-body pb-0">
                                                <!--begin::Header-->
                                                <div class="d-flex align-items-center mb-5">
                                                    <!--begin::User-->
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <!--begin::Avatar-->
                                                        <div class="symbol symbol-50px me-5">
                                                            <img src="assets/img/ins-2.jpeg" alt="">
                                                        </div>
                                                        <!--end::Avatar-->
                                                        <!--begin::Info-->
                                                        <div class="d-flex flex-column">
                                                            <a href="#"
                                                                class="text-gray-900 text-hover-primary fs-6 fw-bold">
                                                                د.محمد شلوف</a>
                                                            <span class="text-gray-400 fw-bold">طب،علوم طبية</span>

                                                        </div>
                                                        <!--end::Info-->
                                                    </div>
                                                    <!--end::User-->
                                                    <!--begin::Menu-->
                                                    <div class="my-0">
                                                        <div class="rating">
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!--end::Menu-->
                                                </div>
                                                <!--end::Header-->
                                                <!--begin::Post-->
                                                <div class="mb-5">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <p class="text-gray-800 fw-normal mb-5">
                                                            <div
                                                                style="border: 1px solid #f1416c;border-radius: 10px;text-align: center;padding: 10px;background: #f1416c0d;">
                                                                <span class="badge badge-danger"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 12:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-danger mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    01/08/2025
                                                                </span>

                                                            </div>

                                                            </p>
                                                        </div>
                                                        <div class="col-md-6"
                                                            style="text-align: center;margin-top: 17px;">
                                                            <div
                                                                style="border: 1px solid #50cd89;border-radius: 10px;text-align: center;padding: 10px;background: #50cd890d;">
                                                                <span class="badge badge-success"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 01:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-success mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    05/09/2025
                                                                </span>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" style="text-align: left;">
                                                            <button class="btn btn-danger  btn-sm m-2"> <i
                                                                    class="fa fa-close"></i> إسترجاع </button>
                                                            <button class="btn btn-success btn-sm m-2"> <i
                                                                    class="fa fa-check-circle"></i> قبول </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end::Post-->
                                                <!--begin::Separator-->
                                                <div class="separator mb-4"></div>
                                                <!--end::Separator-->
                                                <!--begin::Reply input-->

                                                <!--edit::Reply input-->
                                            </div>
                                            <!--end::Body-->
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="card mb-5 mb-xl-8 mt-5">
                                            <!--begin::Body-->
                                            <div class="card-body pb-0">
                                                <!--begin::Header-->
                                                <div class="d-flex align-items-center mb-5">
                                                    <!--begin::User-->
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <!--begin::Avatar-->
                                                        <div class="symbol symbol-50px me-5">
                                                            <img src="assets/img/ins-3.png" alt="">
                                                        </div>
                                                        <!--end::Avatar-->
                                                        <!--begin::Info-->
                                                        <div class="d-flex flex-column">
                                                            <a href="#"
                                                                class="text-gray-900 text-hover-primary fs-6 fw-bold">
                                                                د. نادر التونسي</a>
                                                            <span class="text-gray-400 fw-bold">طب،علوم طبية</span>

                                                        </div>
                                                        <!--end::Info-->
                                                    </div>
                                                    <!--end::User-->
                                                    <!--begin::Menu-->
                                                    <div class="my-0">
                                                        <div class="rating">
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!--end::Menu-->
                                                </div>
                                                <!--end::Header-->
                                                <!--begin::Post-->
                                                <div class="mb-5">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <p class="text-gray-800 fw-normal mb-5">
                                                            <div
                                                                style="border: 1px solid #f1416c;border-radius: 10px;text-align: center;padding: 10px;background: #f1416c0d;">
                                                                <span class="badge badge-danger"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 12:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-danger mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    01/08/2025
                                                                </span>

                                                            </div>

                                                            </p>
                                                        </div>
                                                        <div class="col-md-6"
                                                            style="text-align: center;margin-top: 17px;">
                                                            <div
                                                                style="border: 1px solid #50cd89;border-radius: 10px;text-align: center;padding: 10px;background: #50cd890d;">
                                                                <span class="badge badge-success"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 01:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-success mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    05/09/2025
                                                                </span>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" style="text-align: left;">
                                                            <button class="btn btn-danger  btn-sm m-2"> <i
                                                                    class="fa fa-close"></i> إسترجاع </button>
                                                            <button class="btn btn-success btn-sm m-2"> <i
                                                                    class="fa fa-check-circle"></i> قبول </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end::Post-->
                                                <!--begin::Separator-->
                                                <div class="separator mb-4"></div>
                                                <!--end::Separator-->
                                                <!--begin::Reply input-->

                                                <!--edit::Reply input-->
                                            </div>
                                            <!--end::Body-->
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-5 mb-xl-8 mt-5">
                                            <!--begin::Body-->
                                            <div class="card-body pb-0">
                                                <!--begin::Header-->
                                                <div class="d-flex align-items-center mb-5">
                                                    <!--begin::User-->
                                                    <div class="d-flex align-items-center flex-grow-1">
                                                        <!--begin::Avatar-->
                                                        <div class="symbol symbol-50px me-5">
                                                            <img src="assets/img/ins-1.png" alt="">
                                                        </div>
                                                        <!--end::Avatar-->
                                                        <!--begin::Info-->
                                                        <div class="d-flex flex-column">
                                                            <a href="#"
                                                                class="text-gray-900 text-hover-primary fs-6 fw-bold">
                                                                د. نوري قريميدة</a>
                                                            <span class="text-gray-400 fw-bold">طب،علوم طبية</span>

                                                        </div>
                                                        <!--end::Info-->
                                                    </div>
                                                    <!--end::User-->
                                                    <!--begin::Menu-->
                                                    <div class="my-0">
                                                        <div class="rating">
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                            <div class="rating-label me-2 checked">
                                                                <i class="bi bi-star-fill fs-5"></i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!--end::Menu-->
                                                </div>
                                                <!--end::Header-->
                                                <!--begin::Post-->
                                                <div class="mb-5">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <p class="text-gray-800 fw-normal mb-5">
                                                            <div
                                                                style="border: 1px solid #f1416c;border-radius: 10px;text-align: center;padding: 10px;background: #f1416c0d;">
                                                                <span class="badge badge-danger"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 12:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-danger mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    01/08/2025
                                                                </span>

                                                            </div>

                                                            </p>
                                                        </div>
                                                        <div class="col-md-6"
                                                            style="text-align: center;margin-top: 17px;">
                                                            <div
                                                                style="border: 1px solid #50cd89;border-radius: 10px;text-align: center;padding: 10px;background: #50cd890d;">
                                                                <span class="badge badge-success"> <i
                                                                        class="fa fa-clock text-white m-1"></i> 01:00
                                                                    AM</span>
                                                                <br>
                                                                <span class="badge badge-success mt-2"> <i
                                                                        class="fa fa-calendar text-white m-1"></i>
                                                                    05/09/2025
                                                                </span>

                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" style="text-align: left;">
                                                            <button class="btn btn-danger  btn-sm m-2"> <i
                                                                    class="fa fa-close"></i> إسترجاع </button>
                                                            <button class="btn btn-success btn-sm m-2"> <i
                                                                    class="fa fa-check-circle"></i> قبول </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end::Post-->
                                                <!--begin::Separator-->
                                                <div class="separator mb-4"></div>
                                                <!--end::Separator-->
                                                <!--begin::Reply input-->

                                                <!--edit::Reply input-->
                                            </div>
                                            <!--end::Body-->
                                        </div>
                                    </div>
                                </div>
                                <!--end::List widget 20-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--begin::Col-->

        <!--end::Col-->

    </div>
    <Favorites ref="favRef" />

</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";


export default {
    name: "ReviewList",
    components: {

    },
    data() {
        return {
            categories: [],
            subCategories: [],
            isLoading: true,
            token: localStorage.getItem("access_token"),
            courseCount: 0,
            isLoggedIn: false,
            walletBalance: 0,
            catImagePath: baseUrl + "/images/category/",
            defaultImage: "/assets/img/acad-icon.png",
            student: {},
            loadingCategories: true, // Loading state for categories
            loadingCourses: true, // Loading state for courses
            loadingBalance: true, // Loading state for wallet balance
            currentStep: 1, // بداية في الخطوة 1
            selectedOption: "", // البيانات للـ select box
            textInput: "", // البيانات للـ input text
            numberInput: "", // البيانات للـ input number
            isChecked: false, // البيانات للـ checkbox
        };
    },
    mounted() {
        this.getBalance();
    },
    methods: {
        async getBalance() {
            this.isLoading = true; // Start loading
            try {
                const response = await fetch(
                    `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    this.walletBalance = data.wallet_balance;
                    this.isLoading = false;
                    this.isLoggedIn = true;

                } else {
                    console.error("Failed to fetch balance");
                    this.isLoading = false;

                }
            } catch (error) {
                console.error("Error fetching balance:", error);
            } finally {
                this.loadingBalance = false; // Stop loading
                this.isLoading = false;
            }
        },
        formatDate(date) {
            const options = {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            };
            return new Date(date).toLocaleDateString("en-US", options);
        },
        handleImageError(event) {
            // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
            event.target.src = this.defaultImage;
        }
    },
};
</script>

<style scoped></style>
